import { AfterViewInit, Directive, ElementRef } from '@angular/core';

/**
 * libs
 */
import { init, attach } from 'node-waves';

@Directive({
  selector: '[appWaves]'
})
export class WavesEffectDirective implements AfterViewInit {
  
  constructor(private _el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {

    try {

      init();
  
      // Check if the wave is connected with a angular component or a default html tag
      const isAngularComponent: boolean = this._el.nativeElement.tagName.toLowerCase().indexOf('app') != -1;
      
      // get parent or child
      const elTarget = isAngularComponent ? this._el.nativeElement.firstElementChild : this._el.nativeElement;
      
      // attach waves classes
      attach(elTarget as HTMLElement, ['waves-effect', 'waves-light'])

    }
    catch (err) {
      console.error(err);
    }

  }

}